import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtTextInput from "./NtTextInput";
import NtText from "./NtText";
import NtModalInputTitle from "./NtModalInputTitle";
import { useTheme } from "../context/ThemeContext";

function NtModalInputField({
  containerStyle,
  icon,
  title,
  footer,
  placeholder,
  value,
  setValue,
  onChangeText,
  titleStyle,
  inputStyle,
  renderAction,
  renderSuggestions,
  ...rest
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  const handleChange = (text) => {
    if (setValue) setValue(text);
    if (onChangeText) onChangeText(text);
  };

  return (
    <View style={[styles.container, containerStyle]}>
      {title ? (
        <NtModalInputTitle style={[{ marginLeft: 4, marginBottom: 4 }, titleStyle]}>
          {title}
        </NtModalInputTitle>
      ) : null}

      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <NtTextInput
          icon={icon}
          containerStyle={[styles.input, inputStyle]}
          placeholder={placeholder}
          value={value}
          autoCorrect={false}
          autoCapitalize="none"
          onChangeText={handleChange}
          renderAction={renderAction}
          {...rest}
        />
      </View>

      {renderSuggestions ? (
        <View style={styles.suggestions}>{renderSuggestions}</View>
      ) : null}

      {footer ? (
        <NtText style={[styles.footer, { marginTop: 4, marginLeft: 4 }]}>{footer}</NtText>
      ) : null}
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: { marginBottom: 8 },
    input: {
      flex: 1,
      paddingHorizontal: 12,
      height: 38,
    },
    suggestions: {
      backgroundColor: t.surface2,
      borderBottomLeftRadius: t.radius,
      borderBottomRightRadius: t.radius,
      borderColor: t.borderSoft,
      borderWidth: 1,
      borderTopWidth: 0,
    },
    footer: { fontSize: 11, color: t.textMute, fontStyle: "italic" },
  });

export default NtModalInputField;
